import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Tree } from 'antd';
const TreeSelectOptions = ({ data }) => {
    var _a, _b;
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const onExpand = (expandedKeysValue) => {
        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };
    const onCheck = (checkedKeysValue) => {
        var _a, _b;
        const treeData = ((_a = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _a === void 0 ? void 0 : _a.data) || [];
        const checkedKeys = new Set(checkedKeysValue);
        if (treeData) {
            checkedKeysValue === null || checkedKeysValue === void 0 ? void 0 : checkedKeysValue.forEach((key) => {
                var _a;
                const node = treeData.find((item) => item.key === key);
                if (node && node.children) {
                    (_a = node.children) === null || _a === void 0 ? void 0 : _a.forEach((childNode) => {
                        checkedKeys.delete(childNode === null || childNode === void 0 ? void 0 : childNode.value);
                    });
                }
            });
        }
        (_b = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _b === void 0 ? void 0 : _b.setParentChildValue(Array.from(checkedKeys));
    };
    const onClick = (checkedKeysValue) => {
        console.log('onCLick', checkedKeysValue);
    };
    return (_jsx(Tree, { checkable: true, onExpand: onExpand, expandedKeys: expandedKeys, autoExpandParent: autoExpandParent, onCheck: onCheck, onClick: onClick, checkedKeys: (_a = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _a === void 0 ? void 0 : _a.value, treeData: data.treeSelect ? data.treeSelect.data : {}, style: {
            maxHeight: '250px',
            overflow: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgba(0, 0, 0, 0.2) rgba(255, 255, 255, 0.1)'
        } }, `${(_b = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _b === void 0 ? void 0 : _b.title}_tree_view`));
};
export default TreeSelectOptions;
